import React from 'react';
import { useTheme } from '../../../../contexts/ThemeContext';
import { cn } from '../../../../lib/utils';
import { XIcon } from '../../../../components/ui/Icons';
import { CardHeader, CardTitle, CardDescription, Button } from '../../../../components/ui';

const ApprovalTemplateHeader = ({ selectedRecord, onClose }) => {
  const { theme } = useTheme();

  return (
    <CardHeader className="pb-3">
      <div className="flex items-center justify-between">
        <div>
          <CardTitle className={cn("text-lg", theme.text.primary)}>
            {selectedRecord ? `Template Details` : "Select a template"}
          </CardTitle>
          <CardDescription className={cn("text-sm", theme.text.secondary)}>
            {selectedRecord ? `${selectedRecord.name || selectedRecord.id}` : "Choose a template to view details"}
          </CardDescription>
        </div>
        <Button
          variant="ghost"
          size="lg"
          onClick={onClose}
          className="h-10 w-10 p-0 hover:bg-red-50 hover:text-red-600 dark:hover:bg-red-900/20 dark:hover:text-red-400"
        >
          <XIcon className="h-5 w-5" />
        </Button>
      </div>
    </CardHeader>
  );
};

export default ApprovalTemplateHeader;

